"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactPerson = void 0;
const virginity_ts_1 = require("virginity-ts");
const address_1 = require("../value-objects/address");
class ContactPerson {
    constructor(obj) {
        this.address = new address_1.Address(obj.address);
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.id = obj.id;
        this.phone = obj.phone ? obj.phone.filter(phone => !!phone.phoneNumber) : [];
        this.email = obj.email ? obj.email.filter(email => !!email) : [];
        this.remarks = obj.remarks;
    }
    static empty() {
        return new ContactPerson({
            address: {},
            firstName: "",
            lastName: "",
            phone: [],
            email: [],
            remarks: "",
        });
    }
    static sorted(list) {
        return [...list].sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
    get fullName() { return `${this.firstName} ${this.lastName}`; }
    get vcard() {
        const telType = (tel) => {
            if (tel.startsWith("04") || tel.startsWith("+324")) {
                return "cell";
            }
            else {
                return "home";
            }
        };
        const address = this.address.street ? [{
                type: "home",
                street: `${this.address.street} ${this.address.number}`,
                city: this.address.city,
                zip: this.address.zipCode,
                country: "Belgium",
            }] : null;
        const obj = {
            name: {
                first: this.firstName,
                last: this.lastName,
            },
            categories: ["Speelplein (contactpersonen)"],
            note: "Geimporteerde contactpersoon (speelplein)",
            tel: this.phone.map(p => {
                return { number: p.phoneNumber, type: telType(p.phoneNumber) };
            }),
        };
        return virginity_ts_1.compile(address ? Object.assign({}, { adr: address }, obj) : obj);
    }
    withId(id) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { id }));
    }
    withFirstName(firstName) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { firstName }));
    }
    withLastName(lastName) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { lastName }));
    }
    withAddress(address) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { address }));
    }
    withEmail(email) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { email }));
    }
    withPhone(phone) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { phone }));
    }
    withRemarks(remarks) {
        return new ContactPerson(Object.assign(Object.assign({}, this), { remarks }));
    }
}
exports.ContactPerson = ContactPerson;
//# sourceMappingURL=contact-person.js.map